/* Eagle Leather: compare drawer helpers (2026-10-01). Loaded by snippets/el-compare-specs.liquid (toolbar mode).
   Pillar's compare.js appends one <td> per product into each row after its per-product section fetch, and removes
   them again on close / remove. We watch the table (no compare.js edits) and:
   1. hide EL rows (.el-compare-row--optional) where every compared product is empty (td[data-el-empty]);
   2. mark rows whose product cells are all identical (data-el-same) for the "Highlight differences" toggle. */
(() => {
  const update = (table) => {
    table.querySelectorAll('tr[data-compare-key]').forEach((row) => {
      const cells = Array.from(row.querySelectorAll(':scope > td:not(.td-label)'));
      if (row.classList.contains('el-compare-row--optional')) {
        row.hidden = cells.length > 0 && cells.every((td) => td.hasAttribute('data-el-empty'));
      }
      const texts = cells.map((td) => td.textContent.replace(/\s+/g, ' ').trim().toLowerCase());
      const same = row.dataset.compareKey !== 'info' && texts.length > 1 && texts.every((t) => t === texts[0]);
      row.toggleAttribute('data-el-same', same);
    });
  };

  const init = (drawer) => {
    if (drawer.dataset.elCompare) return;
    drawer.dataset.elCompare = '1';
    const table = drawer.querySelector('.compare-table');
    const btn = drawer.querySelector('.el-compare-diff');
    if (!table) return;
    // setTimeout, not requestAnimationFrame: rAF is paused in background tabs, which left empty rows showing.
    let timer = 0;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => update(table), 50);
    }).observe(table, { childList: true, subtree: true });
    btn?.addEventListener('click', () => {
      const on = btn.getAttribute('aria-pressed') !== 'true';
      btn.setAttribute('aria-pressed', String(on));
      table.classList.toggle('el-compare--diff', on);
    });
  };

  const run = () => document.querySelectorAll('compare-drawer').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();
